import { CircularProgress, IconButton } from "@mui/material";
import React, { useState } from "react";
import * as XLSX from "xlsx";
import {
  API_URL,
  BootstrapTooltip,
  chekEmptyField,
  convertJalaaliToGregorian,
  handleSendMessage,
} from "src/utilities";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import { IAppUser } from "src/interface/IUser";
import { useMutation } from "@tanstack/react-query";
import { useAuth } from "src/context/auth";
import { TypeUser } from "src/interface/enum/TypeUser";
import { getRoutes } from "src/utilities/routes";
import { ITransaction } from "src/interface/ITransaction";
import { TransactionType } from "src/interface/enum/TransactionType";
import moment from "jalali-moment";

export default function ImportExcelButton({
  notify,
  refetch,
}: {
  notify: any;
  refetch: any;
}) {
  const { user } = useAuth();
  const Routes = getRoutes();
  const { mutateAsync: insertAsync, isPending } = useMutation({
    mutationFn: async (body: any) => {
      const response = await fetch(Routes.TransactionRoutes, {
        method: "POST",
        headers: {
          Accept: "*/*",
          "Content-Type": "application/json-patch+json",
          Authorization: `Bearer ${user?.token}`,
        },
        body: JSON.stringify(body),
      });
      return await response.json();
    },
    onSuccess: (responseData) => {
      JSON.stringify(responseData);
    },
    onError: (error) => {
      console.log(error);
    },
  });
  const { mutateAsync: getCustomerByCaseNumber } = useMutation({
    mutationFn: async (caseNumber: string) => {
      try {
        const response = await fetch(
          Routes.UsersRoutes + "caseNumber/" + caseNumber,
          {
            method: "GET",
            headers: {
              Aceept: "application/json",
            },
          }
        );
        if (response.ok) {
          return await response.json(); // بازگشت اطلاعات مشتری
        }
        return null; //
      } catch (error) {
        console.error("Error fetching customer:", error);
        return null;
      }
    },

    onError: (error) => {
      notify.show("خطا در دریافت اطلاعات", {
        severity: "error",
        autoHideDuration: 3000,
      });
      console.log(error);
    },
  });

  const handleFileUpload = (event: any) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();

      reader.onload = async (e: any) => {
        const binaryStr = e.target.result;
        const workbook = XLSX.read(binaryStr, { type: "binary" });
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];

        const sheetData: any[] = XLSX.utils.sheet_to_json(sheet) ?? [];
        if (sheetData.length > 0) {
          // ایجاد آرایه از عملیات‌های غیرهمزمان (Promise)
          const promises = sheetData.map(
            async (row: ITransaction, index: number) => {
              console.log("🚀 ~ row:", row);
              //const customer = getCustomerByUserId(row)
              if (
                row.caseNumber !== "" &&
                row.caseNumber !== undefined &&
                row.caseNumber !== null
              ) {
                const customerInfo = await getCustomerByCaseNumber(
                  row.caseNumber
                );
                console.log("🚀 ~ customerInfo:", customerInfo);
                if (customerInfo) {
                  const customerRef = customerInfo.id;
                  console.log("🚀 ~ customerRef:", customerRef);
                  const NewTransaction: ITransaction = {
                    agreementId: undefined,
                    amount: row.amount,
                    caseNumber: row.caseNumber,
                    customerRef: customerRef,
                    description: row.description,
                    docNumber: row.docNumber,
                    //@ts-ignore
                    isDebit: row.isDebit === "1",
                    transactionDate: moment(
                      row.transactionDate,
                      "jYYYY/jMM/jDD"
                    )
                      .locale("en")
                      .format("YYYY/MM/DD"),
                    transactionType: TransactionType.Manual,
                  };
                  const res = await insertAsync(NewTransaction);
                  console.log("🚀 ~ res:", res);

                  if (res.status === true) {
                  } else {
                    handleSendMessage(
                      notify,
                      " کاربر  با شماره پرونده " + NewTransaction.caseNumber,

                      "error",
                      5000,
                      "error" + index
                    );
                  }
                }
              }
            }
          );

          try {
            // صبر کردن برای پایان تمام عملیات‌های insertAsync
            await Promise.all(promises);

            // زمانی که همه‌ی عملیات‌ها به پایان رسید
            refetch && refetch(); // فراخوانی مجدد داده‌ها
            handleSendMessage(
              notify,
              "ورود اطلاعات با موفقیت به انجام رسید",
              "success"
            );
          } catch (error) {
            // در صورت بروز خطا
            handleSendMessage(notify, "خطا در هنگام ثبت داده‌ها.", "error");
          }
        }
      };

      reader.readAsBinaryString(file);
    }
  };

  return (
    <BootstrapTooltip title="افزودن تراکنش ها از طریق فایل Excel">
      <IconButton
        disabled={isPending}
        size="large"
        color="warning"
        component="label" // تبدیل به یک عنصر <label>
      >
        {(isPending && <CircularProgress size={20} />) || (
          <>
            <UploadFileIcon />
            <input type="file" hidden onChange={handleFileUpload} />
          </>
        )}
      </IconButton>
    </BootstrapTooltip>
  );
}
